import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";

const OverviewSection = lazy(() => import("./OverviewSection"));
const DynamicLearningSection = lazy(() => import("./DynamicLearningSection"));
const BenefitSection = lazy(() => import("./BenefitSection"));
const SupportSection = lazy(() => import("./SupportSection"));
const FeaturesSection = lazy(() => import("./FeaturesSection"));

const Education = () => {
  return (
    <>
      <Helmet>
        <title>LENTERA education programs, hands-on-training support.</title>
        <meta
          name="description"
          content="Empower students with LENTERA’s dynamic education programs. Gain industry-relevant skills, hands-on training, personalized dashboards and seamless access to resources for academic success and career readiness."
        />
        <meta
          name="keywords"
          content="LENTERA education programs, hands-on-training support."
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <OverviewSection />
        <DynamicLearningSection />
        <BenefitSection />
        <SupportSection />
        <FeaturesSection />
      </Suspense>
    </>
  );
};

export default Education;
